import { render } from "./patientsView.vue?vue&type=template&id=7c993b5a&scoped=true"
import script from "./patientsView.vue?vue&type=script&lang=js"
export * from "./patientsView.vue?vue&type=script&lang=js"

import "./patientsView.vue?vue&type=style&index=0&id=7c993b5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c993b5a"]])

export default __exports__